var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 18.825C13.2568 18.9419 12.6291 19.0005 12 19C7.52197 19 3.73197 16.057 2.45697 12C2.80024 10.9081 3.32896 9.88346 4.01997 8.971M9.87797 9.879C10.4406 9.31634 11.2038 9.00025 11.9995 9.00025C12.7952 9.00025 13.5583 9.31634 14.121 9.879C14.6836 10.4417 14.9997 11.2048 14.9997 12.0005C14.9997 12.7962 14.6836 13.5593 14.121 14.122M9.87797 9.879L14.121 14.122M9.87797 9.879L14.12 14.12M14.121 14.122L17.412 17.412M9.87997 9.88L6.58997 6.59M6.58997 6.59L2.99997 3M6.58997 6.59C8.20233 5.54957 10.0811 4.9974 12 5C16.478 5 20.268 7.943 21.543 12C20.839 14.2305 19.3773 16.1446 17.411 17.411M6.58997 6.59L17.411 17.411M17.411 17.411L21 21",
    stroke: "#9CA3AF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordEyeOff);
export default __webpack_public_path__ + "static/media/password-eye-off.3ce7062ff07820fb64b43dbc89a9c66f.svg";
export { ForwardRef as ReactComponent };